export default __webpack_public_path__ + "static/media/Square.d74a0b76.svg";